import * as React from 'react'

import { InteractionStatusId } from '../interaction.interface'

const interactionStatusLabel: { [key in InteractionStatusId]: string } = {
  [InteractionStatusId.Ordered]: 'Ordered',
  [InteractionStatusId.Cancelled]: 'Cancelled',
  [InteractionStatusId.Completed]: 'Completed',
  [InteractionStatusId.Delivered]: 'Delivered',
  [InteractionStatusId.Expired]: 'Expired',
  [InteractionStatusId.InProgress]: 'In Progress',
  [InteractionStatusId.NotStarted]: 'Not Started',
  [InteractionStatusId.Pending]: 'Pending',
  [InteractionStatusId.Removed]: 'Removed',
  [InteractionStatusId.DelegatedToRemote]: 'Delivered to intakeDI Anywhere',
}

export const getInteractionStatusLabel = (visitStatus: InteractionStatusId) =>
  interactionStatusLabel[visitStatus] ?? '–'

interface Props {
  className?: string
  status?: InteractionStatusId
}

const InteractionStatus = function ({ className, status }: Props) {
  const value = status ? getInteractionStatusLabel(status) : '–'
  return <span className={className}>{value}</span>
}

export default InteractionStatus
